import Vue from "vue";
import Vuex from "vuex";

import env from "./modules/env";
import config from "./modules/config";
import login from "./modules/login";
import account from "./modules/account";
import rewardProgram from "./modules/reward-program";
import store from "./modules/store";
import locker from "./modules/locker";
import vending from "./modules/vending";
import vendingCategory from "./modules/vending-category";
import lockerDelivery from "./modules/locker-delivery";
import operator from "./modules/operator";
import category from "./modules/category";
import user from "./modules/user";
import catalog from "./modules/catalog";
import scaleProduct from "./modules/scale-product";
import purchase from "./modules/purchase";
import productCreation from "./modules/product-creation";
import orders from "./modules/orders";
import cart from "./modules/cart";
import transaction from "./modules/transaction";
import buyNowPayLater from "./modules/buy-now-pay-later";
import settlement from "./modules/settlement";
import access from "./modules/access";
import credit from "./modules/credit";
import report from "./modules/report";
import feedback from "./modules/feedback";
import inventoriesRefills from "./modules/inventories-refills";
import refillsStock from "./modules/refills-stock";
import i18n from "./modules/i18n";
import upload from "./modules/upload";
import purchasesInvoices from "./modules/purchases-invoices";
import stockOperation from "./modules/stock-operations";
import bags from "./modules/bags";
import stockout from "./modules/stockout";
import clientCoupon from "./modules/clients-coupon";
import invoicesPack from "./modules/invoices-pack";
import invoices from "./modules/invoices";
import clients from "./modules/clients";
import totem from "./modules/totem";
import products from "./modules/products";
import productCombo from "./modules/product-combo";

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const persistedStatePaths = [
  "env",
  "login",
  "account",
  "store",
  "locker",
  "lockerDelivery",
  "purchase",
  "category",
  "i18n",
  "config",
  "stockOperation"
];

const getPersistedState = (key, storage) => {
  try {
    const persistedState = JSON.parse(storage.getItem(key));
    if (
      persistedState &&
      persistedState.account &&
      Object.prototype.hasOwnProperty.call(persistedState.account, "openMart")
    ) {
      delete persistedState.account.openMart;
      storage.setItem(key, JSON.stringify(persistedState));
    }
    return persistedState;
  } catch (e) {
    return undefined;
  }
};

const getStateToPersist = state => {
  return persistedStatePaths.reduce((persistedState, path) => {
    if (path === "account") {
      const account = Object.assign({}, state.account);
      delete account.openMart;
      persistedState.account = account;
    } else {
      persistedState[path] = state[path];
    }
    return persistedState;
  }, {});
};

export default new Vuex.Store({
  modules: {
    env,
    config,
    login,
    account,
    rewardProgram,
    store,
    locker,
    vending,
    vendingCategory,
    lockerDelivery,
    operator,
    category,
    user,
    catalog,
    scaleProduct,
    purchase,
    productCreation,
    orders,
    cart,
    transaction,
    buyNowPayLater,
    settlement,
    access,
    credit,
    report,
    feedback,
    inventoriesRefills,
    refillsStock,
    i18n,
    upload,
    purchasesInvoices,
    stockOperation,
    bags,
    stockout,
    clientCoupon,
    invoicesPack,
    invoices,
    clients,
    totem,
    products,
    productCombo
  },
  plugins: [
    createPersistedState({
      getState: getPersistedState,
      reducer: getStateToPersist
    })
  ]
});
